import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { uniqueKey } from 'global/common/keys'
import { sortingHelpers, updateArrayInclusion } from 'global/common/sorting'
import MotionDiv from 'global/motions/MotionDiv'
import _ from 'lodash'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { gameScoringTypes } from 'projectSpecific/sports/cnr/reducers/SportsSeasonReducer'
import { CreatePlayoffContext } from 'projectSpecific/sports/create/CreatePlayoff'
import { SectionHeaders } from 'projectSpecific/sports/elements/standings/SectionHeaders'
import { useSportsFilters } from 'projectSpecific/sports/useHelpers/useSportsFilters'
import { useContext, useState } from 'react'
import { Icon } from 'semantic-ui-react'
import { SportsStandingsContext } from './LeagueStandings'
import { TeamSectionRecord } from './TeamSectionRecord'

export const SectionStandingz = ({
  levelKey,
  teamKey,
  _teamsFavs,
  sectionOpts,
  forOverview,
  caption,
}) => {

  const { forPlayoff, availableTeams } = sectionOpts ?? {}

  const parentContext = useContext(ParentContext);
  const { fns, states } = parentContext ?? {}
  const { appUser_state } = states ?? {}
  const { navigation_fns } = fns

  const { appUser } = appUser_state ?? {}
  const { profileData } = appUser ?? {}
  const { favs_info } = profileData ?? {}
  const { eventFavs } = favs_info ?? {};
  const team_favs = eventFavs && eventFavs['teams']

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { currentSeason_info, teams_info, matches_info, details_info, sportSettings_info, sportsShowType, links_score } = sportsSeason_state ?? {}
  const { teams } = teams_info ?? {}
  const { matches, matches_playoffs } = matches_info ?? {}
  const { gameScoringType, gameAllowTies, _sportsModeSport } = currentSeason_info ?? {}
  const { sortStandingsByPoints } = links_score ?? {}

  const { showRankingsInStandings } = sportSettings_info ?? {}
  const { playoffTeams: playoffTeams_season } = teams_info ?? {}
  const { details, sectionPlayoffTeams } = details_info ?? {}
  const { playoffTeamsPerSection } = details ?? {}

  const sportsStandingsContext = useContext(SportsStandingsContext)
  const { sportsStandings_state, sportsStandings_handlers } = sportsStandingsContext ?? {}
  const { selected_teams } = sportsStandings_state ?? {}

  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_handlers } = createPlayoffContext ?? {}

  const { sortSectionStandings } = useSportsFilters()

  const [selected_team, setSelectedTeam] = useState()
  const [showRemaining, setShowRemaining] = useState()
  const handleShowRemaining = () => setShowRemaining(!showRemaining)

  const handleSelectedTeams = (team) => {
    const _sts = [...selected_teams]
    updateArrayInclusion(_sts, team._itemKey)
    sportsStandings_handlers.handleSet_selected_teams(_sts)
  }

  const handlePlayoffClick = (e, team, compareOnly) => {
    if (e) { e.cancelBubble = true };
    if (e && e.stopPropagation) e.stopPropagation();
    createPlayoff_handlers.handleSelect_playoffTeam(team, compareOnly)
  }

  const handleSelectClick = (e, team) => {
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
    handleSelectedTeams(team)
  }

  const handleTeamClick = (e, team) => {
    if (forPlayoff) {
      _allowSelect && setSelectedTeam(selected_team ? null : team)
      createPlayoff_handlers.handleSelect_playoffTeamRecord(team)
      if (allowSelect) {
        allowSelect && handlePlayoffClick(e, team, true)
      }
    } else {
      team && navigation_fns && sportsSeason_handlers.handleGoTo_team(navigation_fns, team)
    }
  }

  const isNonSection = false

  const tableType = 'tst'

  let valueW = 2

  const motion_wrapper = (content) => <MotionDiv>
    {content}
  </MotionDiv>

  const getSortedTeams = (teams) => {
    if (sortSectionStandings && teams) {
      return sortSectionStandings(
        teams,
        playoffTeamsPerSection,
        sectionPlayoffTeams,
        _sportsModeSport,
        forPlayoff,
        true
      );
    }
    return [];
  };

  const getSelectedStandings = (selectedTeam, sectionTeams) => {
    const _selected = []
    const index = _.findIndex(sectionTeams, { _itemKey: selectedTeam });
    let _indexes = []
    if (index === 0) {
      _indexes = [0, 1, 2]
    } else if (index === _.size(sectionTeams) - 1) {
      _indexes = [index - 2, index - 1, index]
    } else {
      _indexes = [index - 1, index, index + 1]
    }
    _.forEach(_indexes, idx => {
      _selected.push(teams[_indexes[idx]])
    })
    return _selected;
  }


  const standingsHeader = SectionHeaders({ gameScoringType, tableType, isNonSection, gameAllowTies })

  const standingsTable = (tmz, sectionKey) => {
    if (_.isEmpty(tmz)) { return }
    let _teams = tmz
    if (forOverview) {
      const _teamz = getSelectedStandings(teamKey, tmz)
      // _teams = _teamz
    }
    const sortedTeams = getSortedTeams(_teams)
    const rows = []
    let rowIndex = 0;
    _.forEach(sortedTeams, (team, teamKey) => {
      const rowKey = 'r' + rowIndex
      rows.push(<TeamSectionRecord
        isNonSection={isNonSection}
        tableType={tableType}
        valueW={valueW}
        team={team}
        rowKey={rowKey}
        team_favs={team_favs}
        forPlayoff={forPlayoff}
        handleTeamClick={handleTeamClick}
      />)
    })
    return rows
  }

  let cn = 'standings-container'
  let cnt = 'standings-table '

  switch (gameScoringType) {
    case gameScoringTypes.half:
      cnt += ' ties'
      break;
    default:
      cnt += ' no-ties'
      break;
  }

  if (gameScoringType === gameScoringTypes.matchPoints) {
    cnt += ' pts'
  }

  function isFavInSection(tmz, _teamsFavs) {
    let isFav;
    Object.keys(_teamsFavs).forEach(tf => {
      const stf = _.find(tmz, { _itemKey: tf })
      if (stf) { isFav = true }
    })
    return isFav
  }

  const levelSections = (lk) => {
    const levelTeams = _.groupBy(teams, 'levels')
    const _team = teamKey ? teams?.[teamKey] : {}
    const { sections, levels } = _team ?? {}
    const level_key = teamKey && levels ? levels : lk
    const _levelTeams = levelTeams?.[level_key]
    const _sectionTeams = _.groupBy(_levelTeams, 'sections')
    if (teamKey) {
      return { _levelKey: level_key, currentSection: { [sections]: _sectionTeams[sections] } }
    } else {
      return { _levelKey: level_key, currentSection: _sectionTeams }
    }
  }

  const levelSectionStandings = () => {

    const { currentSection } = levelSections(levelKey)
    const _currentSections = sortingHelpers.sortByKey(currentSection)

    const _sectionTables = []

    // loop the section in the level
    _.forEach(_currentSections, (tmz, sectionKey) => {

      const isFavSection = _teamsFavs && isFavInSection(tmz, _teamsFavs)

      const sl = `${levelKey}-${sectionKey}`

      const secSs = <div className={cn} key={uniqueKey('ss', 'shw', levelKey, sectionKey)}>
        <div key={uniqueKey('ss', 'sh', levelKey, sectionKey)} className={'standings-header'}>
          {isFavSection ? <div><Icon name={'star'} color={'blue'} /></div> : <div></div>}
          {caption || _.startCase(sectionKey)}
          <div><Icon name='calendar outline' color={showRemaining ? 'blue' : 'grey'} onClick={(e) => { handleShowRemaining(e) }} /></div>
        </div>
        <div className={cnt}>
          <div className='match-date-matches'>
            <MotionDiv origin='sectionStandingz'>
              <div>{standingsHeader}</div>
              {standingsTable(tmz, sectionKey)}
            </MotionDiv>
          </div>
        </div>
      </div >

      if (isFavSection) {
        _sectionTables.unshift(secSs)
      } else {
        _sectionTables.push(secSs)
      }
    })
    return _sectionTables
  }

  return <div className='standings-container-legend'>
    {levelSectionStandings()}
  </div>
}
